module.exports = __webpack_public_path__ + "static/img/zengjia.088ffcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/zengjia.png
// module id = TaJr
// module chunks = 24